import { useCallback, useMemo } from 'react';

import {
  useDataRefId,
  useFetch,
  useMutation,
  useRefetch,
} from '@bingads-webui-react/overreact';

import { environmentLookupFn } from '../../../../../env/env-instance';

import { destroySpec } from '../../__specs/entity/destroy-spec';
import { fetchSpec, refetchSpec } from '../../__specs/entity/fetch-spec';
import { mutationSpec } from '../../__specs/entity/mutation-spec';

import { dataRefIdDecorator } from './hook-decorators';

export function useAccount(variables, config = {}) {
  const dataRefId = useDataRefId(dataRefIdDecorator(), environmentLookupFn);

  const defaultConfig = useMemo(() => ({
    fetch: config.fetch || {},
    refetch: config.refetch || {},
    mutation: config.mutation || {},
    destroy: config.destroy || {},
  }), [config]);

  const {
    fetch: fetchConfig,
    refetch: refetchConfig,
    mutation: mutationConfig,
    destroy: destroyConfig,
  } = defaultConfig;

  const [data, error] = useFetch(dataRefId, fetchSpec, variables, fetchConfig);
  const mutateFn = useMutation(dataRefId, mutationSpec, mutationConfig);
  const destroyFn = useMutation(dataRefId, destroySpec, destroyConfig);
  const refetchFn = useRefetch(dataRefId, refetchSpec, refetchConfig);

  const update = useCallback((newData, ...rest) => {
    mutateFn(variables, newData, ...rest);
  }, [mutateFn, variables]);

  // FIXME: likezh: Why would destroy need data?
  const destroy = useCallback((newData, ...rest) => {
    destroyFn(variables, newData, ...rest);
  }, [destroyFn, variables]);

  const refetch = useCallback((parameter = {}, ...rest) => {
    refetchFn(
      {
        variables: {
          ...variables,
          ...parameter.variables,
        },
        payload: parameter.payload,
      },
      refetchConfig,
      ...rest
    );
  }, [refetchFn, refetchConfig, variables]);

  return [{ data, error }, { update, destroy, refetch }];
}
